import React, { useCallback } from 'react'
import { CardElement } from '@stripe/react-stripe-js'
import { CardElementChangeHandler, CardElementStripeProps } from '../types'
import { ErrorMessage } from 'donate/shared/error_message'
import { FormValues } from 'donate/types'
import { StripeCCFieldsComp } from './types'
import { StripeCardElement, StripeElementStyle } from '@stripe/stripe-js'
import { connect } from 'formik'
import { useIsStripeLoaded } from '../../stripe_context'
import { useResetFieldOnMethodChange } from '../use_reset_field_on_method_change'

//TODO: Improve types
export const StripeCCFields: StripeCCFieldsComp = connect<{}, FormValues>(({ formik }) => {
  const handleChange: CardElementChangeHandler = useCallback(
    (event) => {
      if (event.error) {
        formik.setFieldTouched('stripe_token', true, false)
        formik.setFieldError('stripe_token', i18n.t(`donate.errors.stripe_cc_${event.error.code}`))
        formik.setSubmitting(false)
      } else {
        formik.setFieldTouched('stripe_token', true, false)
        formik.setFieldError('stripe_token', undefined)
      }
    },
    [formik]
  )
  const isStripeLoaded = useIsStripeLoaded()
  const onReady = useResetFieldOnMethodChange<StripeCardElement>(formik.values.payment_method)

  const show = formik.values.payment_method === 'stripe_cc'
  if (!isStripeLoaded)
    return (
      <div className="donations-form-stripe-fields mb-6">
        <h4>{i18n.t('donate.stripe_cc_fields.headline')}</h4>
        <p>{i18n.t('donate.errors.stripe_cc_unavailable')}</p>
      </div>
    )

  // beacuse of the new library's behaviour unmounting Stripe components will cause an exception,
  // unless it's removed together with it's provider
  return (
    <div style={{ display: show ? 'block' : 'none' }} className="donations-form-stripe-fields mb-6">
      <h4>
        <span>{i18n.t('donate.stripe_cc_fields.headline')}</span>
        <span>*</span>
      </h4>
      <CardElement onReady={onReady} onChange={handleChange} id="card-element" {...cardElementProps} />
      <ErrorMessage field="stripe_token" />
    </div>
  )
})

const style: StripeElementStyle = {
  base: {
    'color': '#32325d',
    'lineHeight': '18px',
    'fontFamily': '"Helvetica Neue", Helvetica, sans-serif',
    'fontSmoothing': 'antialiased',
    'fontSize': '16px',
    '::placeholder': {
      color: '#aab7c4',
    },
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a',
  },
}

const cardElementProps: CardElementStripeProps = {
  options: {
    hidePostalCode: true,
    style,
  },
}

StripeCCFields.displayName = 'StripeCCFields'
